import { useCallback, useEffect, useRef, useState } from "react";

export default function useHorizontalDragScroll() {
  const scrollRef = useRef(null);

  const dragStateRef = useRef({
    isDown: false,
    startX: 0,
    scrollLeft: 0,
    hasMoved: false,
  });

  const [isDraggingScroll, setIsDraggingScroll] = useState(false);

  const onMouseDown = useCallback((event) => {
    const el = scrollRef.current;
    if (!el) return;

    /**
     * Important :
     * On autorise le déplacement horizontal uniquement si on clique
     * directement sur le fond du board, pas sur une colonne, pas sur une carte,
     * pas sur un bouton.
     */
    if (event.target !== el) {
      return;
    }

    dragStateRef.current = {
      isDown: true,
      startX: event.pageX,
      scrollLeft: el.scrollLeft,
      hasMoved: false,
    };

    setIsDraggingScroll(true);
  }, []);

  const onMouseMove = useCallback((event) => {
    const el = scrollRef.current;
    const state = dragStateRef.current;

    if (!el || !state.isDown) return;

    event.preventDefault();

    const walk = (event.pageX - state.startX) * 1.15;

    if (Math.abs(walk) > 4) {
      state.hasMoved = true;
    }

    el.scrollLeft = state.scrollLeft - walk;
  }, []);

  const stopDragging = useCallback(() => {
    if (!dragStateRef.current.isDown) return;

    dragStateRef.current.isDown = false;

    window.setTimeout(() => {
      setIsDraggingScroll(false);
    }, 80);
  }, []);

  useEffect(() => {
    window.addEventListener("mouseup", stopDragging);
    window.addEventListener("mouseleave", stopDragging);

    return () => {
      window.removeEventListener("mouseup", stopDragging);
      window.removeEventListener("mouseleave", stopDragging);
    };
  }, [stopDragging]);

  return {
    scrollRef,
    isDraggingScroll,
    dragScrollHandlers: {
      onMouseDown,
      onMouseMove,
      onMouseUp: stopDragging,
      onMouseLeave: stopDragging,
    },
  };
}